import { browser, dev } from '$app/environment';
import posthog from 'posthog-js'
import { PostHog } from 'posthog-node'
import { waitUntil } from '@vercel/functions';

const apiKey = 'phc_lehGMQwhrF3i3G1KmmrFZs9dUVDLLCs0IfNg4ckXB88'

export function initializeAnalytics() {
    if (dev) return;

    try {
        if (browser) {
            posthog.init(
                apiKey,
                {
                    api_host: 'https://eu.posthog.com',
                    capture_pageview: false,
                    capture_pageleave: false
                }
            )
        }

    } catch (error) {
        console.error('could not initialize analytics', error);
    }
};

let track: typeof posthog.capture;
let posthogServer: PostHog;
export async function logEvent(name: string, params: Parameters<typeof track>[1] & { userId: string }) {
    if (dev) return;

    try {
        if (browser) {
            posthog.capture(name, params)
        } else {
            waitUntil(logEventOnServer(name, params))
        }
    } catch (error) {
        console.error('analytic event could not be logged. name = ' + name, error);
    }
}

async function logEventOnServer(name: string, params: Parameters<typeof track>[1] & { userId: string }) {
    if (!posthogServer) {
        const PostHog = (await import('posthog-node')).PostHog
        posthogServer = new PostHog(apiKey, {
            host: 'https://eu.posthog.com',
            flushAt: 1,
            flushInterval: 0
        })
    }
    posthogServer.capture({
        distinctId: params.userId,
        event: name,
        properties: params
    })
}

export function shutdownServerAnalytics() {
    if (!posthogServer) return;

    waitUntil(posthogServer.shutdownAsync())
}